import React, { useState } from 'react';
import AWS from 'aws-sdk';
import { Link } from "@mui/material";

const GetUrl = (filelink) => {
  const [ signedUrl, setSignedUrl ] = useState(null);

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESS,
    secretAccessKey: process.env.REACT_APP_SECRET,
    region: process.env.REACT_APP_REGION,
  });


  const s3 = new AWS.S3();

  const params = {Bucket: 'cu1', Key: filelink, Expires: 60*5};
  s3.getSignedUrl('getObject', params, function (err, url) {
      setSignedUrl(url);
  });

  return (
    signedUrl
  );
};

export default GetUrl;
